import dashboard from '../frontEnd/it/dashboard.json'
import findProducts from '../frontEnd/it/findProducts.json'
import common from '../frontEnd/it/common.json'
import frameClass from '../frontEnd/it/frameClass.json'
import sourcing from '../frontEnd/it/sourcing.json'
import listProduct from '../frontEnd/it/listProduct.json'
import orders from '../frontEnd/it/orders.json'
import customService from '../frontEnd/it/customService.json'
import siteOptimization from '../frontEnd/it/siteOptimization.json'
import subscribe from '../frontEnd/it/subscribe.json'
import setting from '../frontEnd/it/setting.json'
import shoppingCart from '../frontEnd/it/shoppingCart.json'
import message from '../frontEnd/it/message.json'
import partnership from '../frontEnd/it/partnership.json'
const it =  {
    ...dashboard,
    ...findProducts,
    ...common,
    ...frameClass,
    ...sourcing,
    ...listProduct,
    ...orders,
    ...customService,
    ...siteOptimization,
    ...subscribe,
    ...setting,
    ...shoppingCart,
    ...message,
    ...partnership
};
export default it;